import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CollapsibleSection from './CollapsibleSection';
import AssetTile from './AssetTile';

function EnvelopePicker({
    envelopes = [],
    selectEnvelope = () => {},
    deleteEnvelope = () => {},
    editEnvelope = () => {},
}) {
    const [envelopeSearch, setEnvelopeSearch] = useState('');
    const [filteredEnvelopes, setFilteredEnvelopes] = useState(envelopes);

    const isSearching = envelopeSearch.length > 0;

    useEffect(() => {
        const filtered = envelopes.filter((envelope) => envelope.name.toLowerCase().includes(envelopeSearch.toLowerCase()));
        setFilteredEnvelopes(filtered);
    }, [envelopes, envelopeSearch]);

    const getEnvelopesByCategory = (categoryName) => envelopes.filter((envelope) => envelope.category === categoryName);

    return (
        <div className="envelope-picker margin-t-24px">
            <div className="search-field height-40px margin-b-24px">
                <label htmlFor="envelope-picker-search" className="sr-only">Search for an Envelope</label>
                <i className="fa fa-search"></i>
                <input
                    id="envelope-picker-search"
                    type="text"
                    onChange={(e) => setEnvelopeSearch(e.target.value)}
                    placeholder="Search for an envelope"
                />
            </div>
            {
                isSearching && <CollapsibleSection
                    title={`Search Results (${filteredEnvelopes.length})`}
                    initiallyExpanded={true}
                >
                    <div className="asset-grid">
                        {filteredEnvelopes.map((envelope) => <AssetTile
                            key={envelope.id}
                            asset={envelope}
                            editable={envelope.is_editable || false}
                            deletable={envelope.can_delete || false}
                            legacy={envelope.builder_id === null}
                            selectAsset={() => selectEnvelope(envelope)}
                            deleteAsset={() => deleteEnvelope(envelope)}
                            editAsset={() => editEnvelope(envelope)}
                        />)}
                    </div>
                </CollapsibleSection>
            }
            {
                !isSearching && <CollapsibleSection
                    title={`Your Branded Envelopes (${getEnvelopesByCategory('branded').length})`}
                    initiallyExpanded={false}
                >
                    <div className="asset-grid">
                        {getEnvelopesByCategory('branded').map((envelope) => <AssetTile
                            key={envelope.id}
                            asset={envelope}
                            editable={envelope.is_editable || false}
                            deletable={envelope.can_delete || false}
                            legacy={envelope.builder_id === null}
                            selectAsset={() => selectEnvelope(envelope)}
                            deleteAsset={() => deleteEnvelope(envelope)}
                            editAsset={() => editEnvelope(envelope)}
                        />)}
                    </div>
                </CollapsibleSection>
            }
            {
                !isSearching && <CollapsibleSection
                    title={`Holiday Envelopes (${getEnvelopesByCategory('holiday').length})`}
                    initiallyExpanded={false}
                >
                    <div className="asset-grid">
                        {getEnvelopesByCategory('holiday').map((envelope) => <AssetTile
                            key={envelope.id}
                            asset={envelope}
                            editable={false}
                            deletable={envelope.can_delete || false}
                            legacy={envelope.builder_id === null}
                            selectAsset={() => selectEnvelope(envelope)}
                            deleteAsset={() => deleteEnvelope(envelope)}
                            editAsset={() => editEnvelope(envelope)}
                        />)}
                    </div>
                </CollapsibleSection>
            }
            {
                !isSearching && <CollapsibleSection
                    title={`Legacy Envelopes (${getEnvelopesByCategory('legacy').length})`}
                    initiallyExpanded={false}
                >
                    <div className="asset-grid">
                        {getEnvelopesByCategory('legacy').map((envelope) => <AssetTile
                            key={envelope.id}
                            asset={envelope}
                            editable={false}
                            deletable={envelope.can_delete || false}
                            legacy={envelope.builder_id === null}
                            selectAsset={() => selectEnvelope(envelope)}
                            deleteAsset={() => deleteEnvelope(envelope)}
                            editAsset={() => editEnvelope(envelope)}
                        />)}
                    </div>
                </CollapsibleSection>
            }
        </div>
    );
}

EnvelopePicker.propTypes = {
    envelopes: PropTypes.array.isRequired,
    selectEnvelope: PropTypes.func,
    deleteEnvelope: PropTypes.func,
    editEnvelope: PropTypes.func,
    expandCategory: PropTypes.bool,
};

export default EnvelopePicker;
